import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.WorkflowIdPage.SingletonSteps.AutoApprovalActivator', {
    enableAutoApproval: 'Enable Auto-Approval',
    description: 'Requests matching the defined rules will be automatically approved.',
    hide: 'Hide',
    enable: 'Enable',
});
